{
  "name": "gobierto-vizzs",
  "version": "3.2.0",
  "description": "Shared data visualizations for Gobierto projects",
  "keywords": [
    "gobierto",
    "visualizations",
    "beeswarm",
    "treemap",
    "gantt",
    "bar",
    "stack"
  ],
  "source": "src/index.js",
  "main": "dist/index.js",
  "module": "dist/module.js",
  "style": "dist/index.css",
  "files": [
    "dist",
    "src"
  ],
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "watch": "parcel watch",
    "prebuild": "rm -rf ./dist/* ./.parcel-cache",
    "build": "parcel build",
    "postversion": "npm run build && git push --follow-tags"
  },
  "author": "populate",
  "license": "ISC",
  "dependencies": {
    "d3-array": "^3.2.4",
    "d3-axis": "^3.0.0",
    "d3-dsv": "^3.0.1",
    "d3-ease": "^3.0.1",
    "d3-force": "^3.0.0",
    "d3-hierarchy": "^3.1.2",
    "d3-interpolate": "^3.0.1",
    "d3-scale": "^4.0.2",
    "d3-selection": "^3.0.0",
    "d3-shape": "^3.2.0",
    "d3-time": "^3.1.0",
    "d3-time-format": "^4.1.0",
    "d3-transition": "^3.0.1"
  },
  "devDependencies": {
    "buffer": "^6.0.3",
    "parcel": "^2.11.0"
  }
}
